import { bindDialog } from "../../../../hooks/use-dialog-state/UseDialogState";
import { UserEditorDialogState, BindUserEditorDialogReturn } from "./UserEditorDialog";

export function bindUserEditorDialog(props: UserEditorDialogState): BindUserEditorDialogReturn {
    return bindDialog(props);
}
